module.exports = __webpack_public_path__ + "d6e491d0e1adebc6ed2bf4b437fc87ed.MP3";